import {useSelector} from 'react-redux';
import {Redirect, Switch} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Session} from 'nutshell-core/session';

import type {NutshellState} from '../../store';
import {InboxPage, INBOX_SEARCH} from '../../ui/inbox/inbox-page';
import {PageWrapper} from '../../ui/layout/page-wrapper';
import {DASHBOARD, ENGAGEMENT} from '../../ui/reports/report-types';
import {PromptedRoute} from '../../util/prompted-route';

import {PageRoute} from '../shared/page-route';

import {EngagementReportEmbedded} from './engagement-report-embedded';
import {EngagementSidebarWrapper} from './engagement-sidebar-wrapper';

type Props = ContextRouter;

export function EngagementRootEmbedded(props: Props) {
    const user = useSelector((state: NutshellState) => Session.getSessionStateUser(state));

    return (
        <PageWrapper
            sidebar={<EngagementSidebarWrapper user={user} isEmbedded={true} {...props} />}
            isEmbedded={true}
        >
            <Switch>
                <Redirect exact={true} from='/inbox' to='/inbox/chat/open' />
                <Redirect exact={true} from='/inbox/dashboard' to='/inbox/chat/open' />
                <Redirect exact={true} from='/inbox/sms' to='/inbox/sms/open' />
                <Redirect exact={true} from='/inbox/settings' to='/inbox/settings/chat' />
                <Redirect
                    exact={true}
                    from='/inbox/reports'
                    to='/inbox/reports/engagement-report'
                />
                <Redirect
                    exact={true}
                    from='/inbox/settings/chat'
                    to='/inbox/settings/chat/engagement-bar'
                />
                <PageRoute
                    // @ts-expect-error
                    exact={true}
                    path='/inbox/reports/engagement-report'
                    component={EngagementReportEmbedded}
                    reportKey={ENGAGEMENT}
                    localStorageKey={'engagement-report-search'}
                />
                <PageRoute
                    // @ts-expect-error
                    exact={true}
                    path='/inbox/:section/:page?/:id?'
                    component={InboxPage}
                    reportKey={DASHBOARD}
                    localStorageKey={INBOX_SEARCH}
                />
            </Switch>
            <PromptedRoute
                routeListType='allow'
                routePaths={
                    // allowed top-level routes
                    [
                        '/inbox/sms',
                        '/inbox/settings/sms',
                        '/inbox/chat',
                        '/inbox/settings/chat',
                        '/inbox/settings/test-chatbot',
                        '/inbox/settings/chat-onboarding',
                        '/inbox/no-access',
                        '/inbox/all',
                        '/inbox/messenger',
                        '/inbox/instagram',
                        '/inbox/settings/facebook',
                        '/inbox/whatsapp',
                        '/inbox/settings/whatsapp',
                        '/inbox/chatbot-threads',
                        '/inbox/reports',
                    ]
                }
            />
        </PageWrapper>
    );
}
